/* eslint-disable import/no-unused-modules */
export const mobileLandscapeWidth = 768; // px
export const desktopWidth = 992; // px
export const nbrOfEventColors = 23;
export const baseFontSize = 14; // px
